import React from "react";
import Sidebar from "./Sidebar";

export default function Shell({ children }) {
  return (
    <div className="min-h-screen bg-[#0B0D12]">
      <Sidebar />
      <main className="md:ml-64 min-h-screen pt-16 md:pt-0">
        <div className="max-w-[1400px] mx-auto px-4 md:px-10 py-6 md:py-8 fade-in">{children}</div>
      </main>
    </div>
  );
}
